import { Component, OnInit } from '@angular/core';
import {VendorService} from '../../../services/vendor.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-vendor-access',
    templateUrl: './vendor-access.component.html',
    styleUrls: ['./vendor-access.component.scss']
})
export class VendorAccessComponent implements OnInit {

    public items: Array<any> = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private vendorService: VendorService,
        private title: Title
    ) {
        this.title.setTitle('EDI - Vendor Access');
    }

    ngOnInit() {

        const params = this.route.snapshot.params;
        this.vendorService.getAccess(params['id'], params['CO1_ID']).subscribe( result => {
            this.items = result.data;
        });
    }

    save() {
        const params = this.route.snapshot.params;
        this.vendorService.setAccess(params['id'], params['CO1_ID'], this.items).subscribe(result => {
            this.router.navigate(['vendors']);
        });
    }

    onCancel() {
        this.router.navigate(['vendors']);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/vendors/vendor-access/vendor-access.component.ts